import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { baseQuery } from '../base/baseQuery'

export const classServiceApi = createApi({
  reducerPath: 'classServiceApi',
  baseQuery: baseQuery,
  tagTypes: ['Class'],
  endpoints: (builder) => ({
    // Fetch all classes
    getAllClasses: builder.query({
      query: () => '/backoffice/class',
      providesTags: (result) => (result ? [{ type: 'Class', id: 'LIST' }] : []),
    }),
    // Fetch a class by ID
    getClassById: builder.query({
      query: (id) => `/classes/${id}`,
      providesTags: (result, error, id) => [{ type: 'Class', id }],
    }),
    // Get Classes by School Level
    getClassesBySchoolLevel: builder.query({
      query: (id) => `/backoffice/school-levels/${id}/classes`,
      providesTags: (result) => (result ? [{ type: 'Class', id: 'LIST' }] : []),
    }),
    // Create a new class
    addClass: builder.mutation({
      query: (newClass) => ({
        url: '/backoffice/class/save',
        method: 'POST',
        body: newClass,
      }),
      invalidatesTags: [{ type: 'Class', id: 'LIST' }],
    }),
    // Update a class
    updateClass: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/backoffice/class/update/${id}`,
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: [{ type: 'Class', id: 'LIST' }],
    }),
    // Delete a class
    deleteClass: builder.mutation({
      query: (id) => ({
        url: `/backoffice/class/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Class', id: 'LIST' }],
    }),
  }),
})

export const {
  useGetAllClassesQuery,
  useGetClassByIdQuery,
  useGetClassesBySchoolLevelQuery,
  useAddClassMutation,
  useUpdateClassMutation,
  useDeleteClassMutation,
} = classServiceApi
